import { useState } from "react";

import RenderIf from "common/components/RenderIf";
import { getWhitelabelCustomization } from "common/helpers/utils";

import SettingsScrollContent from "../SettingsScrollContent";
import Communication from "./Communication";
import Email from "./Email";
import FullName from "./FullName";
import Password from "./Password";

export default function ProfileSettings() {
  const [editingKey, setEditingKey] = useState<"name" | "email" | "password">(
    null,
  );

  function closeEditing() {
    setEditingKey(null);
  }

  return (
    <SettingsScrollContent>
      <div>
        <FullName
          isEditable={!getWhitelabelCustomization()}
          isEditing={editingKey === "name"}
          startEditing={() => setEditingKey("name")}
          closeEditing={closeEditing}
        />
        <Email
          isEditable={!getWhitelabelCustomization()}
          isEditing={editingKey === "email"}
          startEditing={() => setEditingKey("email")}
          closeEditing={closeEditing}
        />
        <RenderIf condition={!getWhitelabelCustomization()}>
          <Password
            isEditing={editingKey === "password"}
            startEditing={() => setEditingKey("password")}
            closeEditing={closeEditing}
          />
          <Communication />
        </RenderIf>
      </div>
    </SettingsScrollContent>
  );
}
